import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import App from './App';

import { unregister } from './registerServiceWorker';

const sentryEnvironment = window.__ENV__.REACT_APP_SENTRY_ENV_NAME;
const sentryBuildNumber = process.env.REACT_APP_SENTRY_BUILD_NUMBER;

Sentry.init({
  dsn: "https://d56c6997bc6a4b6c93f774a8dfa41e82@o4504730772897792.ingest.sentry.io/4505127986003968",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  environment: (sentryEnvironment ? sentryEnvironment : 'dev'),
  release: sentryEnvironment === 'development' ? undefined : `covr-consumer@${sentryBuildNumber}`,
});

const enableHotjar = window.__ENV__.REACT_APP_ENABLE_HOTJAR;

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const Root = () => {
  useEffect(() => {
    if (enableHotjar === 'true') {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:5175282,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `;
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, []);

  return (
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  );
};

const root = createRoot(rootElement);

root.render(<Root />);

unregister();
// registerServiceWorker(); //for some reason this blocked all server requests in a deployed enviornment
